import { LessonProblem, Stack } from '@yandex-int/k-common/typings';
import { Button, MarkdownExtXContent, Text, Tooltip, Popup, SimpleCallback, Link } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS } from 'platform-components/constants';
// @ts-ignore
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { BLOCK_CARDS_COUNT } from 'common.components/constants';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { ReduxTeacherStore } from '../../../typings';

import './stack-modal__header.scss';

interface StoreProps {
    canEditLesson: boolean;
    isContentManager: boolean;
}

interface OwnProps {
    onDeleteFromLesson: SimpleCallback;
    onAddToLesson: SimpleCallback;
    problems: Array<LessonProblem>;
    problemIdsInLesson: Array<number>;
    stack: Stack;
    selectedProblemId: number;
    tooltipShown: boolean;
    scrollToVariants: () => void;
    shouldShowVariantsButton: boolean;
}

interface Props extends OwnProps, StoreProps {}

export class StackModalHeader extends React.Component<Props> {
    componentDidMount() {
        if (this.tooltipRef && this.buttonRef) {
            this.tooltipRef.setOwner(this.buttonRef);
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.tooltipRef && this.buttonRef && prevProps.selectedProblemId !== this.props.selectedProblemId) {
            this.tooltipRef.setOwner(this.buttonRef);
        }
    }

    private tooltipRef: Popup | null;
    private buttonRef: Element | Text | null;

    setTooltipRef = (ref: Popup | null) => {
        this.tooltipRef = ref;
    };

    setButtonRef = (ref: HTMLElement | null) => {
        this.buttonRef = ref ? ReactDOM.findDOMNode(ref) : null;
    };

    render() {
        const {
            canEditLesson,
            isContentManager,
            selectedProblemId: problemId,
            stack,
            problems,
            problemIdsInLesson,
            onDeleteFromLesson,
            onAddToLesson,
            tooltipShown,
            scrollToVariants,
            shouldShowVariantsButton,
        } = this.props;

        const selectedProblemId = problemId || stack.representative.id;
        const isProblemInLesson = problemIdsInLesson.includes(selectedProblemId);
        const selectedProblem = problems.find((p) => p.id === selectedProblemId);
        const selectedProblemIndex = problems.indexOf(selectedProblem!) + 1;
        const hasProblems = problems && problems.length !== 0;

        return (
            <div className="stack-modal__header">
                <span className="stack-modal__title">
                    <span className="stack-modal__title-item">
                        <Text weight={Text.WEIGHT.M}>
                            <MarkdownExtXContent>{stack.name}</MarkdownExtXContent>
                        </Text>
                    </span>
                    {isContentManager && (
                        <span className="stack-modal__title-item-id">
                            <Text id="lessonModal.cmId" values={{ cmId: stack.id }} />
                        </span>
                    )}
                </span>
                {isProblemInLesson && (
                    <div className="stack-modal__link qa-remove-from-lesson">
                        <Link disabled={!canEditLesson} onClick={onDeleteFromLesson} pseudo theme={Link.THEME.PRIMARY}>
                            <Text id="stackModal.deleteFromLesson" weight={Text.WEIGHT.M} />
                        </Link>
                    </div>
                )}

                {shouldShowVariantsButton && (
                    <div className="stack-modal__scroll-to-variants">
                        <Button onClick={scrollToVariants} view={Button.VIEW.SECONDARY}>
                            <Text id="stackModal.goToVariants" weight={Text.WEIGHT.M} />
                        </Button>
                    </div>
                )}

                {isProblemInLesson ? (
                    <div className="stack-modal__status">
                        <Text
                            id="stackModal.addedToLessonVariant"
                            values={{ variantNumber: selectedProblemIndex }}
                            weight={Text.WEIGHT.M}
                        />
                    </div>
                ) : (
                    <div className="stack-modal__add-to-lesson-wrapper">
                        <Button
                            className="stack-modal__add-to-lesson"
                            disabled={!hasProblems || !canEditLesson}
                            innerRef={this.setButtonRef}
                            onClick={onAddToLesson}
                        >
                            <Text id="stackModal.addToLesson" weight={Text.WEIGHT.M} />
                        </Button>
                        <Tooltip
                            onPopupRef={this.setTooltipRef}
                            popupProps={{
                                autoclosable: false,
                                shown: tooltipShown,
                                direction: POPUP_DIRECTIONS.BOTTOM,
                                axis: POPUP_AXIS.CENTER,
                            }}
                            theme={Tooltip.THEME.ERROR}
                        >
                            <Text id="cardsCount.block" values={{ cardsBlock: BLOCK_CARDS_COUNT }} />
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore): StoreProps => ({
    canEditLesson: lessonSelectors.getCanEditLesson(storeState),
    isContentManager: getIsContentManager(storeState),
});

const wrapped = connect(mapStateToProps)(StackModalHeader);
wrapped.displayName = 'StackModalHeader';

export default wrapped;
